import './style.sass';
import React, { useEffect, useState, useMemo } from 'react';

function DashedSegments() {
  const [numberOfSegments, setNumberOfSegments] = useState(0);

  useEffect(() => {
    function handleResize() {
      const parentElement = document.querySelector('.dashed-parent');
      const calculatedSegmentsCount = Math.ceil(parentElement.offsetWidth / 30);
      setNumberOfSegments(calculatedSegmentsCount);
    }

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const colorsForSegments = useMemo(() => {
    const colors = ['#00a0e2', '#515151', '#ffd900', '#bdbdbd'];
    return Array.from({ length: 1000 }).map(() => {
      const randomIndex = Math.floor(Math.random() * colors.length);
      return colors[randomIndex];
    });
  }, []);

  return (
    <div className="dashed-parent">
      {colorsForSegments.slice(0, numberOfSegments).map((color, index) => (
        <div key={index} className="dashed-segment" style={{ backgroundColor: color }} />
      ))}
    </div>
  );
}

export default DashedSegments;
